/**
 * Extract a user-facing error message from an API error response.
 */
export function getApiErrorMessage(error, fallback = "Something went wrong.") {
  const data = error?.response?.data;
  if (!data) return fallback;

  if (data.Message) return data.Message;
  if (data.message) return data.message;
  if (data.detail) return data.detail;
  if (data.title && data.status === 400) return data.title;

  if (typeof data === "string" && data.trim()) return data;

  return fallback;
}

/**
 * Build a display message from a ClientResponse-style payload.
 */
export function getClientResponseErrorMessage(data, fallback = "Something went wrong.") {
  if (!data) return fallback;

  const parts = [data.Message || data.message, ...(data.Errors || data.errors || [])].filter(
    Boolean,
  );

  return parts.length > 0 ? parts.join("\n") : fallback;
}
